import createGetRequestThunk from "../redux_functions/create_get_request_thunk";
import {GET_SMS} from "./sms_type";
import {getSmsUserList} from "../../../../communication_system/axios_apis/axios_apis";

export const getSmsUserAsync = createGetRequestThunk(GET_SMS,getSmsUserList);
